import axiosInstance from '../variables/api/axiosInstance';
import { avecLibelleTraduit } from '../i18n/libelles';

const BASE = '/v1/agents';

const unwrapList = (res) => {
  const d = res?.data?.data;
  if (Array.isArray(d)) return d;
  if (d?.content && Array.isArray(d.content)) return d.content;
  return [];
};

const unwrap = (res) => res?.data?.data;

export async function loginAgent(matricule, pin) {
  return unwrap(await axiosInstance.post(`${BASE}/auth/login`, { matricule, pin }));
}

export async function creerAgent(payload) {
  return unwrap(await axiosInstance.post(`${BASE}`, payload));
}

export async function getAgent(trackingId) {
  return unwrap(await axiosInstance.get(`${BASE}/${trackingId}`));
}

export async function listerAgents() {
  return unwrapList(await axiosInstance.get(`${BASE}`));
}

export async function listerAgentsParPays(paysCode) {
  return unwrapList(await axiosInstance.get(`${BASE}/pays/${paysCode}`));
}

export async function suspendrAgent(trackingId) {
  return unwrap(await axiosInstance.put(`${BASE}/${trackingId}/suspendre`));
}

export async function reactiverAgent(trackingId) {
  return unwrap(await axiosInstance.put(`${BASE}/${trackingId}/reactiver`));
}

export const STATUTS_AGENT = avecLibelleTraduit({
  ACTIF:     { color: 'success' },
  SUSPENDU:  { color: 'warning' },
  INACTIF:   { color: 'default' },
}, 'referentiels:statutsAgentVerbalisateur');
